module.exports = __webpack_public_path__ + "img/a.336779bc.jpg";